import gql from "graphql-tag";

import { Fragment, Group } from "../types";

export const GROUP_FRAGMENT = gql`
  fragment GroupFragment on Group {
    id
    type
    name
    description
    canInsert
    canDestroy
  }
`;

export type GroupFragment = Fragment<
  Group,
  Pick<Group, "id" | "name" | "description" | "type" | "canInsert" | "canDestroy">
>;
